<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{title.replace('create', 'add')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="closeModal">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <slot></slot>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">{{ctaCancel}}</button>
                <button type="button"
                        :disabled="!state"
                        @click="proceed"
                        class="btn btn-primary">{{ctaProceed.replace('create', 'add')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "ModalBase",
    props: {
      title: {
        type: String
      },
      ctaCancel: {
          type: String,
          default: "Cancel"
      },
      ctaProceed: {
          type: String,
          default: "Ok"
      },
      state: {
          type: Boolean,
          default: true
      }
    },
    methods: {
        closeModal() { this.$emit('close-modal', true); },
        proceed() { this.$emit('proceed', true); },
    },
    data() {
      return {
        massUnit: null,
      };
    },
  };
</script>

<style scoped lang="scss">
  @import "../../../src/assets/scss/variablesx";

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-title,
  button {
    text-transform: capitalize;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>
